'use client';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Link } from 'react-router-dom';

interface SubscriptionStatusProps {
  subscriptionSpend: number;
  subscriptionLimit: number;
  currentlySubscribed: boolean;
}

export function SubscriptionStatus({
  subscriptionSpend,
  subscriptionLimit,
  currentlySubscribed,
}: SubscriptionStatusProps) {
  const creditUsagePercentage = (subscriptionSpend / subscriptionLimit) * 100;

  return (
    <div className="mt-6 space-y-2">
      <Card>
        <CardHeader>
          <CardTitle>Credit Usage</CardTitle>
          <CardDescription>Monitor your current credit usage and limits</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="text-sm font-medium">
                {subscriptionSpend} / {subscriptionLimit} credits used
              </div>
              <div className="text-sm text-muted-foreground">{creditUsagePercentage.toFixed(1)}%</div>
            </div>
            <Progress value={(subscriptionSpend / subscriptionLimit) * 100} className="h-2" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Subscription Status</CardTitle>
          <CardDescription>
            {currentlySubscribed
              ? 'Thank you for subscribing!'
              : 'Subscribe to support future development and get access to advanced features!'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="mb-4">
            By subscribing, you get access to advanced AI technologies that are otherwise very costly, while also
            helping support future awesome features!
          </p>
          <Link to="/subscription">
            <Button variant={currentlySubscribed ? 'outline' : 'default'}>
              {currentlySubscribed ? 'Manage Subscription' : 'Subscribe Now'}
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
